import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  FormGroup,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutline from "@mui/icons-material/PersonOutline";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import { borderRadius } from "@mui/system";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useMutation } from "@tanstack/react-query";
import { Tribhujadigitalform } from "../../api/services";
import { toast } from "react-toastify";
// import { pp1 } from "../../assets";


const steps = [
  "EOI PROCESS & PROJECT BRIEF",
  "SUBMIT YOUR DETAILS",
  "SUBMIT UNIT PREFERENCES",
  "INDICATIVE PRICE RANGE",
  "KNOW YOUR CUTOMER (KYC)"
];
const customInputStyle = {
  "& .MuiOutlinedInput-root": {
    height: "38px",

    display: "flex",
    alignItems: "center",

    "& fieldset": {
      borderColor: "#8fb3d9",
    },

    "&:hover fieldset": {
      borderColor: "#0f63a5",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#0f63a5",
    },
  },

  "& .MuiOutlinedInput-input": {
    padding: "0 14px",
    height: "38px",
    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",

    fontSize: "14px",
  },
};

const PrestigeGoldenGrove = () => {
  const [activeStep, setActiveStep] = useState(0);
  const stepperContainerRef = useRef<HTMLDivElement>(null);
  // CHECKBOX STATE
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (stepperContainerRef.current) {
      const container = stepperContainerRef.current;

      const stepWidth =
        container.scrollWidth / steps.length;

      container.scrollTo({
        left: activeStep * stepWidth - stepWidth,
        behavior: "smooth",
      });
    }
  }, [activeStep]);
  // NEXT BUTTON
  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    secondaryFirstName: "",
    secondaryLastName: "",
    mobile: "",
    whatsapp: "",
    email: "",
    currentLocation: "",

    // STEP 3 FIELDS
    unitPreference1: "",
    unitPreference2: "",
    floorPreference: "",

    facing: [] as string[],

    //step 4 fileds
    basePriceRange: "",
    paymentPreference: "",

    //step 5 fileds
    panNumber: "",
    aadhaarNumber: "",
    passportNumber: "",
  });
  // const handleNext = () => {
  //   if (activeStep < steps.length - 1) {
  //     setActiveStep((prev) => prev + 1);
  //   }
  // };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value, checked, type } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const mutation = useMutation({
    mutationFn: Tribhujadigitalform,

    onSuccess: (response) => {
      toast.success(
        response?.data?.message ||
        "Application Submitted Successfully"
      );

      setFormData({
        firstName: "",
        lastName: "",
        secondaryFirstName: "",
        secondaryLastName: "",
        mobile: "",
        whatsapp: "",
        email: "",
        currentLocation: "",
        unitPreference1: "",
        unitPreference2: "",
        floorPreference: "",
        facing: [],
        basePriceRange: "",
        paymentPreference: "",
        panNumber: "",
        aadhaarNumber: "",
        passportNumber: "",
      });

      setActiveStep(0);
    },

    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
        "Submission failed"
      );
    },
  });

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",

        // FULL PAGE BG IMAGE
        backgroundImage: `
          
          url("https://dprstorage.b-cdn.net/RW/leadgen/mandatehero1.png")
        `,

        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",

        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",

        py: 6,
      }}
    >
      {/* RIGHT SIDE FORM ONLY */}
      <Container
        maxWidth="xl"
        sx={{
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: {
              xs: "100%",
              md: "800px",
            },

            borderRadius: "10px",
            overflow: "hidden",

            // background: "rgba(255,255,255,0.92)",

            backdropFilter: "blur(10px)",

            boxShadow: "0 15px 50px rgba(0,0,0,0.18)",
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              background: "#0f63a5",
              color: "#fff",
              textAlign: "center",
              py: 3,
              px: 3,
            }}
          >
            <Typography

              variant="h3"
              sx={{

                fontWeight: 500,
                lineHeight: 1.2,
                color: "white",
                fontFamily: "Futura,' sans-serif' !important",
              }}
            >
              Tribhuja @ Tellapur
            </Typography>

            {/* <Typography
              sx={{
                fontSize: {
                  xs: "22px",
                  md: "38px",
                },
                mt: 1,
                fontWeight: 300,
              }}
            >
              EXPRESSION OF INTEREST IS LIVE !
            </Typography> */}

            <Typography
              sx={{
                mt: 1,
                fontSize: "17px",
                opacity: 0.9,
                color: "white"
              }}
            >
              Submit your apartment preference here.
            </Typography>
          </Box>

          {/* FORM BODY */}
          <Box
            sx={{
              p: {
                xs: 2,
                md: 5,
              },
              mb: 4
            }}
          >
            <Box
              ref={stepperContainerRef}
              sx={{
                width: "100%",
                overflowX: {
                  xs: "auto",
                  md: "visible",
                },

                scrollBehavior: "smooth",

                "&::-webkit-scrollbar": {
                  height: "6px",
                },

                "&::-webkit-scrollbar-thumb": {
                  background: "#0f63a5",
                  borderRadius: "10px",
                },
              }}
            >
              <Box
                sx={{
                  minWidth: {
                    xs: "700px",
                    md: "100%",
                  },
                }}
              >
                <Stepper
                  activeStep={activeStep}
                  alternativeLabel
                  sx={{
                    mb: {
                      xs: 4,
                      md: 8,
                    },

                    "& .MuiStepConnector-line": {
                      borderTopWidth: "3px",
                      borderColor: "#0f63a5",
                    },

                    "& .MuiStepLabel-label": {
                      mt: 1,
                      color: "#0f63a5",
                      fontWeight: 600,

                      fontSize: {
                        xs: "11px",
                        sm: "13px",
                        md: "14px",
                      },

                      lineHeight: 1.3,
                    },

                    "& .MuiStepIcon-root": {
                      fontSize: {
                        xs: "34px",
                        sm: "38px",
                        md: "30px",
                      },

                      color: "#9db3d1",
                    },

                    "& .MuiStepIcon-root.Mui-active": {
                      color: "#0f63a5",
                    },

                    "& .MuiStepIcon-root.Mui-completed": {
                      color: "#0f63a5",
                    },

                    "& .MuiStepIcon-text": {
                      fill: "#fff",
                      fontSize: {
                        xs: "12px",
                        md: "16px",
                      },
                      fontWeight: 700,
                    },
                  }}
                >
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "12px",
                            },

                            fontWeight: 600,

                            textAlign: "center",

                            // SHOW LABELS IN MOBILE ALSO
                            display: "block",

                            whiteSpace: "normal",

                            lineHeight: 1.2,
                          }}
                        >
                          {label}
                        </Typography>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </Box>


            {/* STEP 1 */}
            {activeStep === 0 && (
              <Box>
                {/* TERMS BOX */}
                <Box
                  sx={{
                    border: "1px solid #0f63a5",
                    borderRadius: "4px",
                    p: {
                      xs: 2,
                      md: 2,
                    },
                    background: "rgba(255,255,255,0.72)",
                    textAlign: "start",
                  }}
                >
                  {/* TOP TEXT */}
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#0f63a5",
                      mb: 1,
                      fontWeight: 500,
                      textAlign: "start",
                    }}
                  >
                    Here's what potential buyers need to know:
                  </Typography>

                  {/* ORDER LIST */}
                  <Box
                    component="ol"
                    sx={{
                      // pl: "30px",
                      // m: 0,
                      listStyleType: "decimal", // This makes numbers appear
                      listStylePosition: "outside", // Positions bullets/numbers outside the text

                      "& li": {
                        mb: 0.5,
                        // lineHeight: 1.8,
                        color: "#000",
                        fontSize: "15px",
                        textAlign: "start",
                        // marginLeft: "10px", // Adds space between number and text
                      },
                    }}
                  >
                    <li>
                      <strong>1.</strong> The Price mentioned is Basic Sale Price, Prices excluding GST, Advance maintenance, Sinking fund and Stamp duty & other charges.
                    </li>

                    <li>
                      <strong>2.</strong> Prices may vary based on the option selected.
                    </li>

                    <li>
                      <strong>3.</strong> First-Come, First-Served: Unit allotments will follow a fair and transparent process—first come, first served. So, if you're interested, please submit your unit preference at the earliest.
                    </li>

                    <li>
                      <strong>4. Pricing:</strong> The initial offered price is limited to the first few allotments. Please Note - This EOI process is non-binding, not offering for sale and subject to company discretion.
                    </li>
                  </Box>

                  {/* BOTTOM TEXT */}
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 2,
                      lineHeight: 1.8,
                      fontSize: "15px",
                      color: "#1d1d1d",
                      textAlign: "start",
                    }}
                  >
                    Feel free to reach out if you have any further queries or if you'd like to discuss
                    the project in more detail. We're here to make your home-buying journey smooth and
                    exciting!
                  </Typography>
                </Box>

                {/* CHECKBOX */}
                <Box
                  sx={{
                    mt: 2,
                    textAlign: "start"
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={(e) =>
                          setChecked(e.target.checked)
                        }
                        sx={{
                          color: "#0f63a5",

                          "&.Mui-checked": {
                            color: "#0f63a5",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          color: "#1d1d1d",
                          fontSize: "16px",
                        }}
                      >
                        I accept the Terms and Conditions.
                      </Typography>
                    }
                  />
                </Box>

                {/* PROJECT DETAILS */}
                <Box
                  sx={{
                    mt: 1,
                    textAlign: "start",
                  }}
                >
                  {/* INTRO */}
                  <Typography
                    sx={{
                      // lineHeight: 1.9,
                      fontSize: "15px",
                      mb: 1,
                      color: "#1d1d1d",
                    }}
                  >
                    <strong>Tribhuja</strong> Kollur ORR Exit 2, Hyderabad

                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: 1.9,
                      fontSize: "15px",
                      mb: 2,
                      color: "#1d1d1d",
                    }}
                  >
                    This upcoming project stands as a landmark
                    in Tellapur, offering premium residences
                    with expansive layouts, world-class
                    amenities, and a thoughtfully designed
                    master plan for modern lifestyle
                    conveniences.
                  </Typography>

                  {/* OVERVIEW TITLE */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#0f63a5",
                      fontWeight: 700,
                      mb: 1,
                      fontSize: "16px",
                      textAlign: "start",
                    }}
                  >
                    📑 Project Overview:
                  </Typography>

                  {/* OVERVIEW GRID */}
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "520px",
                      mb: 2,
                    }}
                  >
                    {[
                      ["Total Land Area", " 9.16 Acres"],
                      ["Total Towers/Wings", " 9 Tower"],
                      [
                        "Structure",
                        " 4 Basements + Ground + 37 Floors",
                      ],
                      ["Total Floors", "G+37"],
                      ["Total Units", "1730 Units"],
                      [
                        "Clubhouse  ",
                        " 1 Lakh Sq. Ft.",
                      ],
                      ["Open Space ", "76% Open Space"],
                      ["Floor-to-Floor Height", "10’6"],
                      ["Possession", "Under Development"],
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          mb: 0.5,
                        }}
                      >
                        {/* LEFT */}
                        <Typography
                          variant="body2"
                          sx={{
                            width: "180px",
                            fontSize: "15px",
                            color: "#1d1d1d",
                            fontWeight: 600,
                          }}
                        >
                          - {item[0]}
                        </Typography>

                        {/* CENTER */}
                        <Typography
                          sx={{
                            width: "20px",
                            fontSize: "15px",
                          }}
                        >
                          :
                        </Typography>

                        {/* RIGHT */}
                        <Typography
                          variant="body2"
                          sx={{
                            flex: 1,
                            fontSize: "15px",
                            color: "#1d1d1d",
                          }}
                        >
                          {item[1]}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  {/* CONFIG TITLE */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#0f63a5",
                      fontWeight: 700,
                      mb: 1,
                      fontSize: "18px",
                      textAlign: "start",
                    }}
                  >
                    🏡 Available Configurations & Sizes:
                  </Typography>

                  {/* CONFIG GRID */}
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "420px",
                    }}
                  >
                    {[
                      ["3 BHK Smart", "1677 – 1776 Sq.Ft"],
                      ["3 BHK Prima ", " 2096 – 2112 Sq.Ft."],
                      ["3 BHK + Study", "2289 – 2314 Sq.Ft."],
                      ["4 BHK ", "3125 – 3126 Sq.Ft. "],

                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          mb: 0.5,
                        }}
                      >
                        {/* LEFT */}
                        <Typography
                          variant="body2"
                          sx={{
                            width: "170px",
                            fontSize: "15px",
                            color: "#1d1d1d",
                            fontWeight: 600,
                          }}
                        >
                          {item[0]}
                        </Typography>

                        {/* CENTER */}
                        <Typography
                          sx={{
                            width: "20px",
                            fontSize: "15px",
                          }}
                        >
                          :
                        </Typography>

                        {/* RIGHT */}
                        <Typography
                          variant="body2"
                          sx={{
                            flex: 1,
                            fontSize: "15px",
                            color: "#1d1d1d",
                          }}
                        >
                          {item[1]}
                        </Typography>




                      </Box>



                    ))}
                  </Box>


                  {/* CURRENT OFFER */}
                  <Box
                    sx={{
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#0f63a5",
                        fontWeight: 700,
                        mb: 1.5,
                        fontSize: "20px",
                      }}
                    >
                      🎁 Current Offerings:
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        lineHeight: 2,
                        fontSize: "15px",
                        color: "#1d1d1d",
                      }}
                    >
                      * Exclusive EOI Benefits
                      <br />
                      * Pricing Benefits for early buyers
                      <br />
                      * Preferred Unit Allotment Advantage
                    </Typography>
                  </Box>
                </Box>
                {/* BUTTONS */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    mt: 4,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleBack}
                    sx={{
                      background: "#0f63a5",

                      borderRadius: "40px",

                      width: "110px",
                      height: "48px",

                      textTransform: "none",

                      fontSize: "18px",

                      boxShadow: "none",

                      "&:hover": {
                        background: "#000",
                        boxShadow: "none",
                        color: "white"
                      },
                    }}
                  >
                    Back
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      background: "#0f63a5",

                      borderRadius: "40px",

                      width: "110px",
                      height: "48px",

                      textTransform: "none",

                      fontSize: "18px",

                      boxShadow: "none",

                      "&:hover": {
                        background: "#000",
                        boxShadow: "none",
                        color: "white"
                      },
                    }}
                  >
                    Next
                  </Button>
                </Box>

                {/* PAGE COUNT */}
                <Typography
                  sx={{
                    textAlign: "right",
                    color: "#0f63a5",
                    fontSize: "22px",
                  }}
                >
                  1/5
                </Typography>
              </Box>
            )}


            {/* STEP 2 */}
            {activeStep === 1 && (
              <Box >


                {/* FORM AREA */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,

                  }}
                >
                  {/* PRIMARY APPLICANT */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    {/* LABEL */}
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",
                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.5,
                        mt: 1,
                      }}
                    >
                      PRIMARY APPLICANT

                      NAME <span style={{ color: "red" }}>*</span> :
                    </Typography>

                    {/* INPUTS */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        flex: 1,

                        flexDirection: {
                          xs: "column",
                          md: "row",
                        },
                      }}
                    >
                      {/* FIRST NAME */}
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              firstName: e.target.value,
                            })
                          }
                          InputProps={{
                            startAdornment: (
                              <PersonOutline
                                sx={{
                                  color: "#94a3b8",
                                  mr: 1,
                                }}
                              />
                            ),
                          }}
                          sx={customInputStyle}
                        />

                        {/* <Typography
            variant="body2"
              sx={{
                fontSize: "14px",
                color: "#0f63a5",
                mt: 1,
                textAlign:"start"
              }}
            >
              First Name
            </Typography> */}
                      </Box>

                      {/* LAST NAME */}
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          placeholder="Last Name"
                          value={formData.lastName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lastName: e.target.value,
                            })
                          }
                          sx={customInputStyle}
                        />
                        {/* 
            <Typography
              sx={{
                fontSize: "14px",
                color: "#0f63a5",
                mt: 1,
              }}
            >
              Last Name
            </Typography> */}
                      </Box>
                    </Box>
                  </Box>

                  {/* SECONDARY APPLICANT */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.5,
                        mt: 1,
                      }}
                    >
                      SECONDARY

                      APPLICANT NAME

                      <span
                        style={{
                          fontSize: "14px",
                        }}
                      >
                        (Optional)
                      </span>
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        flex: 1,

                        flexDirection: {
                          xs: "column",
                          md: "row",
                        },
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          placeholder="First Name"
                          value={formData.secondaryFirstName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              secondaryFirstName:
                                e.target.value,
                            })
                          }
                          InputProps={{
                            startAdornment: (
                              <PersonOutline
                                sx={{
                                  color: "#94a3b8",
                                  mr: 1,
                                }}
                              />
                            ),
                          }}
                          sx={customInputStyle}
                        />

                        {/* <Typography
              sx={{
                fontSize: "14px",
                color: "#0f63a5",
                mt: 1,
              }}
            >
              First Name
            </Typography> */}
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          placeholder="Last Name"
                          value={formData.secondaryLastName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              secondaryLastName:
                                e.target.value,
                            })
                          }
                          sx={customInputStyle}
                        />

                        {/* <Typography
              sx={{
                fontSize: "14px",
                color: "#0f63a5",
                mt: 1,
              }}
            >
              Last Name
            </Typography> */}
                      </Box>
                    </Box>
                  </Box>

                  {/* MOBILE */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },
                      }}
                    >
                      MOBILE #{" "}
                      <span style={{ color: "red" }}>
                        *
                      </span>
                    </Typography>

                    <TextField
                      fullWidth
                      placeholder="+91  Mobile Number"
                      value={formData.mobile}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          mobile: e.target.value,
                        })
                      }
                      sx={{
                        ...customInputStyle,
                        maxWidth: "360px",
                      }}
                    />
                  </Box>

                  {/* WHATSAPP */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.4,
                      }}
                    >
                      WHATSAPP or

                      ALTERNATE #
                    </Typography>

                    <TextField
                      fullWidth
                      placeholder="+91  Whatsapp Number"
                      value={formData.whatsapp}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          whatsapp: e.target.value,
                        })
                      }
                      sx={{
                        ...customInputStyle,
                        maxWidth: "360px",
                      }}
                    />
                  </Box>

                  {/* EMAIL */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },
                      }}
                    >
                      EMAIL ID
                    </Typography>

                    <TextField
                      fullWidth
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          email: e.target.value,
                        })
                      }
                      InputProps={{
                        startAdornment: (
                          <EmailOutlined
                            sx={{
                              color: "#94a3b8",
                              mr: 1,
                            }}
                          />
                        ),
                      }}
                      sx={{
                        ...customInputStyle,
                        maxWidth: "360px",
                      }}
                    />
                  </Box>


                  {/*location */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },
                      }}
                    >
                      CURRENT LOCATION
                    </Typography>

                    <TextField
                      fullWidth
                      placeholder="Current Location"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          currentLocation: e.target.value,
                        })
                      }
                      InputProps={{
                        startAdornment: (
                          <LocationOnOutlinedIcon
                            sx={{
                              color: "#94a3b8",
                              mr: 1,
                            }}
                          />
                        ),
                      }}
                      sx={{
                        ...customInputStyle,
                        maxWidth: "360px",
                      }}
                    />
                  </Box>

                  {/* BUTTON */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 5,
                    }}
                  >

                  </Box>
                </Box>
                {/* BUTTONS */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleBack}
                    sx={{
                      background: "#0f63a5",

                      borderRadius: "40px",

                      width: "110px",
                      height: "48px",

                      textTransform: "none",

                      fontSize: "18px",

                      boxShadow: "none",

                      "&:hover": {
                        background: "#000",
                        boxShadow: "none",
                        color: "white"
                      },
                    }}
                  >
                    Back
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                      background: "#0f63a5",

                      borderRadius: "40px",

                      width: "110px",
                      height: "48px",

                      textTransform: "none",

                      fontSize: "18px",

                      boxShadow: "none",

                      "&:hover": {
                        background: "#000",
                        boxShadow: "none",
                        color: "white"
                      },
                    }}
                  >
                    Next
                  </Button>
                </Box>

                {/* PAGE COUNT */}
                <Typography
                  sx={{
                    textAlign: "right",
                    color: "#0f63a5",
                    fontSize: "22px",
                  }}
                >
                  2/5
                </Typography>
              </Box>
            )}

            {/* STEP 3 */}
            {activeStep === 2 && (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  {/* UNIT PREFERENCE 1 */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 2.5,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    {/* LABEL */}
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        minWidth: {
                          md: "180px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.4,
                        mt: 1,
                      }}
                    >
                      UNIT PREFERENCE - 1
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    {/* INPUT */}
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "280px",
                      }}
                    >
                      <TextField
                        select
                        fullWidth
                        value={formData.unitPreference1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            unitPreference1: e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      >
                        <MenuItem value="">
                          Select
                        </MenuItem>

                        <MenuItem value="3BHK">
                          3BHK : 1679 - 1693 sq.ft
                        </MenuItem>

                        <MenuItem value="3BHK">
                          3BHK: 2096 - 2112 sq.ft
                        </MenuItem>

                        {/* <MenuItem value="4BHK">
                          4 BHK
                        </MenuItem> */}
                      </TextField>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#0f63a5",
                          mt: 1,
                          textAlign: "start"
                        }}
                      >
                        Please select your Unit preference
                      </Typography>
                    </Box>
                  </Box>

                  {/* UNIT PREFERENCE 2 */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "220px",
                        },

                        minWidth: {
                          md: "180px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.4,
                        mt: 1,
                      }}
                    >
                      UNIT PREFERENCE - 2 :
                    </Typography>

                    <Box sx={{
                      width: "100%",
                      maxWidth: "280px",
                    }}>
                      <TextField
                        select
                        fullWidth
                        value={formData.unitPreference2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            unitPreference2: e.target.value,
                          })
                        }
                        sx={customInputStyle}

                      >
                        <MenuItem value="">
                          Select
                        </MenuItem>
                        <MenuItem value="3BHK">
                          3BHK : 1679 - 1693 sq.ft
                        </MenuItem>

                        <MenuItem value="3BHK">
                          3BHK: 2096 - 2112 sq.ft
                        </MenuItem>
                      </TextField>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "#0f63a5",
                          fontSize: "14px",
                          textAlign: "start"
                        }}
                      >
                        Please select your Unit preference
                      </Typography>
                    </Box>
                  </Box>

                  {/* FACING */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 4,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: "220px",
                        color: "#0f63a5",
                        // fontSize: "18px",
                        textAlign: "start",
                        lineHeight: 1.5,
                      }}
                    >
                      FACING / VIEW

                      PREFERENCE
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.facing.includes(
                              "East"
                            )}
                            onChange={(e) => {
                              const updated =
                                e.target.checked
                                  ? [
                                    ...formData.facing,
                                    "East",
                                  ]
                                  : formData.facing.filter(
                                    (f) =>
                                      f !== "East"
                                  );

                              setFormData({
                                ...formData,
                                facing: updated,
                              });
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#1d1d1d",
                              // fontSize: "15px",
                              fontWeight: 500,
                            }}
                          >
                            EAST
                          </Typography>
                        }
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.facing.includes(
                              "West"
                            )}
                            onChange={(e) => {
                              const updated =
                                e.target.checked
                                  ? [
                                    ...formData.facing,
                                    "West",
                                  ]
                                  : formData.facing.filter(
                                    (f) =>
                                      f !== "West"
                                  );

                              setFormData({
                                ...formData,
                                facing: updated,
                              });
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#1d1d1d",
                              // fontSize: "15px",
                              fontWeight: 500,
                            }}
                          >
                            West
                          </Typography>
                        }
                      />


                    </FormGroup>
                  </Box>

                  {/* FLOOR PREFERENCE */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        width: "220px",
                        color: "#0f63a5",
                        // fontSize: "18px",
                        textAlign: "start",
                        lineHeight: 1.5,

                      }}
                    >
                      FLOOR PREFERENCE
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    <Box sx={{
                      width: "100%",
                      maxWidth: "280px",
                    }}>
                      <TextField
                        select
                        fullWidth
                        value={formData.floorPreference}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            floorPreference:
                              e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      >
                        <MenuItem value="">
                          Select
                        </MenuItem>

                        <MenuItem value="Lower">
                          05-10
                        </MenuItem>

                        <MenuItem value="Mid">
                          11-15
                        </MenuItem>

                        <MenuItem value="Higher">
                          16-20
                        </MenuItem>
                        <MenuItem value="Higher">
                          21-25
                        </MenuItem>
                        <MenuItem value="Higher">
                          26 & above
                        </MenuItem>
                      </TextField>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "#0f63a5",
                          // fontSize: "14px",
                          textAlign: "start"
                        }}
                      >
                        Please select your floor preference
                        from available options
                      </Typography>
                    </Box>
                  </Box>

                  {/* BUTTONS */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                      mt: 4,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleBack}
                      sx={{
                        background: "#0f63a5",

                        borderRadius: "40px",

                        width: "110px",
                        height: "48px",

                        textTransform: "none",

                        fontSize: "18px",

                        boxShadow: "none",

                        "&:hover": {
                          background: "#000",
                          boxShadow: "none",
                          color: "white"
                        },
                      }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{
                        background: "#0f63a5",

                        borderRadius: "40px",

                        width: "110px",
                        height: "48px",

                        textTransform: "none",

                        fontSize: "18px",

                        boxShadow: "none",

                        "&:hover": {
                          background: "#000",
                          boxShadow: "none",
                          color: "white"
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Box>

                  {/* PAGE COUNT */}
                  <Typography
                    sx={{
                      textAlign: "right",
                      color: "#0f63a5",
                      fontSize: "22px",
                    }}
                  >
                    3/5
                  </Typography>

                </Box>
              </Box>
            )}

            {/* STEP 4 */}
            {activeStep === 3 && (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                  }}
                >
                  {/* BASE PRICE RANGE */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    {/* LABEL */}
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "180px",
                        },

                        minWidth: {
                          md: "180px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.4,
                        mt: 1,
                      }}
                    >
                      BASE PRICE RANGE
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    {/* INPUT */}
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "460px",
                      }}
                    >
                      <TextField
                        select
                        fullWidth
                        value={formData.basePriceRange}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            basePriceRange:
                              e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      >
                        <MenuItem value="">
                          Select
                        </MenuItem>

                        <MenuItem value="7499">
                          ~ 7499 /-
                        </MenuItem>


                      </TextField>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#0f63a5",
                          mt: 1.5,
                          lineHeight: 1.6,
                          textAlign: "start"
                        }}
                      >
                        INDICATIVE ADDITIONAL CHARGES,
                        Floor Rise from 6th floor,
                        Facing, Premium View Amenities,
                        Infra & GAS Pipeline Car Parking(s)
                        Legal & Documentation Corpus &
                        Adv. Maintenance Applicable
                        Taxes/GST & Registration charges
                        as per Govt Norms
                      </Typography>
                    </Box>
                  </Box>

                  {/* PAYMENT PREFERENCE */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,

                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    {/* LABEL */}
                    <Typography
                      variant="body2"
                      sx={{
                        width: {
                          xs: "100%",
                          md: "180px",
                        },

                        minWidth: {
                          md: "180px",
                        },

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        lineHeight: 1.4,
                        mt: 1,
                      }}
                    >
                      PAYMENT

                      PREFERENCE
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    {/* INPUT */}
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "460px",
                      }}
                    >
                      <TextField
                        select
                        fullWidth
                        value={formData.paymentPreference}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            paymentPreference:
                              e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      >
                        <MenuItem value="">
                          Select
                        </MenuItem>

                        <MenuItem value="self">
                          Self
                        </MenuItem>

                        <MenuItem value="self+loan">
                          self + Loan
                        </MenuItem>

                        <MenuItem value="onetimepayment">
                          One Time Payment
                        </MenuItem>
                      </TextField>
                    </Box>
                  </Box>

                  {/* BUTTONS */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                      mt: 4,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleBack}
                      sx={{
                        background: "#0f63a5",

                        borderRadius: "40px",

                        width: "110px",
                        height: "48px",

                        textTransform: "none",

                        fontSize: "18px",

                        boxShadow: "none",

                        "&:hover": {
                          background: "#000",
                          boxShadow: "none",
                          color: "white"
                        },
                      }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{
                        background: "#0f63a5",

                        borderRadius: "40px",

                        width: "110px",
                        height: "48px",

                        textTransform: "none",

                        fontSize: "18px",

                        boxShadow: "none",

                        "&:hover": {
                          background: "#000",
                          boxShadow: "none",
                          color: "white"
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Box>

                  {/* PAGE COUNT */}
                  <Typography
                    sx={{
                      textAlign: "right",
                      color: "#0f63a5",
                      fontSize: "22px",
                    }}
                  >
                    4/5
                  </Typography>
                </Box>
              </Box>
            )}

            {/* step 5 */}

            {activeStep === 4 && (
              <Box>
                {/* HEADING */}
                {/* <Typography
                  sx={{
                    color: "#0f63a5",
                    fontSize: "32px",
                    fontWeight: 500,
                    mb: 5,
                    textAlign: "center",
                  }}
                >
                  Know Your Customer (KYC)
                </Typography> */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  {/* PAN */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        width: "180px",
                        minWidth: "180px",

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        mt: 1,
                      }}
                    >
                      PAN :
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "460px",
                      }}
                    >
                      <TextField
                        fullWidth
                        placeholder="Enter PAN Number"
                        value={formData.panNumber}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            panNumber:
                              e.target.value.toUpperCase(),
                          })
                        }
                        sx={customInputStyle}
                      />

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "#0f63a5",
                          textAlign: "start"
                        }}
                      >
                        Example: ABCDE1234F
                      </Typography>
                    </Box>
                  </Box>

                  {/* AADHAAR */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        width: "180px",
                        minWidth: "180px",

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        mt: 1,
                      }}
                    >
                      Aadhaar Number
                      <span style={{ color: "red" }}>
                        {" "}*
                      </span>
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "460px",
                      }}
                    >
                      <TextField
                        fullWidth
                        placeholder="Enter Aadhaar Number"
                        value={formData.aadhaarNumber}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            aadhaarNumber:
                              e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      />

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "#0f63a5",
                          textAlign: "start"
                        }}
                      >
                        Enter 12 digit Aadhaar Number
                      </Typography>
                    </Box>
                  </Box>

                  {/* PASSPORT */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2.5,
                      flexDirection: {
                        xs: "column",
                        md: "row",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        width: "180px",
                        minWidth: "180px",

                        color: "#0f63a5",
                        // fontSize: "18px",

                        textAlign: {
                          xs: "start",
                          md: "right",
                        },

                        mt: 1,
                      }}
                    >
                      Passport Number
                    </Typography>

                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "460px",
                      }}
                    >
                      <TextField
                        fullWidth
                        placeholder="Passport Number"
                        value={formData.passportNumber}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            passportNumber:
                              e.target.value,
                          })
                        }
                        sx={customInputStyle}
                      />

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "#0f63a5",
                          textAlign: "start"
                        }}
                      >
                        Only for NRI Applicants
                      </Typography>
                    </Box>
                  </Box>

                  {/* BUTTONS */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                      mt: 4,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleBack}
                      sx={{
                        background: "#0f63a5",
                        borderRadius: "10px",
                        width: "110px",
                        height: "48px",
                        textTransform: "none",

                        "&:hover": {
                          background: "#000",
                          color: "white"
                        },
                      }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      disabled={mutation.isPending}
                      onClick={() => mutation.mutate(formData)}
                    >
                      {mutation.isPending
                        ? "Submitting..."
                        : "Submit"}
                    </Button>
                  </Box>

                  {/* PAGE COUNT */}
                  <Typography
                    sx={{
                      textAlign: "right",
                      color: "#0f63a5",
                      fontSize: "22px",
                      mt: 2,
                    }}
                  >
                    5/5
                  </Typography>
                </Box>
              </Box>
            )}
            {/* BUTTONS */}
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 5,
              }}
            >
              <Button
                variant="outlined"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{
                  borderColor: "#0f63a5",
                  color: "#0f63a5",
                  px: 4,
                  py: 1.2,
                  borderRadius: "10px",
                }}
              >
                Back
              </Button>

              {activeStep === steps.length - 1 ? (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    background: "#0f63a5",
                    px: 5,
                    py: 1.2,
                    borderRadius: "10px",

                    "&:hover": {
                      background: "#0f63a5",
                    },
                  }}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{
                    background: "#0f63a5",
                    px: 5,
                    py: 1.2,
                    borderRadius: "10px",

                    "&:hover": {
                      background: "#0f63a5",
                    },
                  }}
                >
                  Next
                </Button>
              )}
            </Box> */}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrestigeGoldenGrove;